document.addEventListener("DOMContentLoaded", function(event) {
  var qq = document.querySelector("#quick-quote-wrapper");
  var qqTable = document.querySelector("#qq-table-wrapper");
  
  if (qq != null) {
    console.log('qq ready');

    //insert quantity label
    var qCells = document.querySelectorAll(".cart-item-row .qty");
    for (i = 0; i < qCells.length; ++i) {
      var newSpan = document.createElement('span');
      newSpan.innerText = "Quantity";
      qCells[i].prepend(newSpan);
    }

    //insert summary label
    var summaryCell = document.querySelector(".summary .qty");
    var summaryLabel = document.createElement('span');
    summaryLabel.innerText = "Summary";
    summaryCell.prepend(summaryLabel);

    var qInputGroups = document.querySelectorAll(".quote-input-group");
    for (i = 0; i < qInputGroups.length; ++i) {
      qInputGroups[i].classList.add("form-field");
    }
    var qInputLabels = document.querySelectorAll(".quote-input-label");
    for (i = 0; i < qInputLabels.length; ++i) {
      qInputLabels[i].classList.add("form-field-title");
      qInputLabels[i].style = '';
    }
    var qInputs = document.querySelectorAll(".quote-input-group input, .quote-input-group textarea");
    for (i = 0; i < qInputs.length; ++i) {
      qInputs[i].classList.add("form-field-input");
      qInputs[i].addEventListener("focus", setActive);
      qInputs[i].addEventListener("blur", toggleFilled);
    }
    
    
     var qForm = document.querySelector(".quote-form");
    
     var formColumns = document.createElement('div');
     formColumns.classList.add("qq-columns");

     var colLeft = document.createElement("div");
     colLeft.classList.add("col--half");

     var colRight = document.createElement("div");
     colRight.classList.add("col--half");

     formColumns.appendChild(colLeft);
     formColumns.appendChild(colRight);

     qqTable.after(formColumns);
     colLeft.appendChild(qForm);

    var qqName = document.createElement('div');
    qqName.classList.add("qq-columns");
    var qqContact = document.createElement('div');
    qqContact.classList.add("qq-columns");

    var fName = document.querySelector(".quote-fname");
    fName.classList.add("col--half");
    qqName.appendChild(fName);

    var lName = document.querySelector(".quote-lname");
    lName.classList.add("col--half");
    qqName.appendChild(lName);

    var email = document.querySelector(".quote-email");
    email.classList.add("col--half");
    qqContact.appendChild(email);

    var phone = document.querySelector(".quote-phone");
    phone.classList.add("col--half");
    qqContact.appendChild(phone);


    document.querySelector("#txtCustomerID").after(qqContact);
    document.querySelector("#txtCustomerID").after(qqName);

    var remarks = document.querySelector("#quote-remarks-wrapper");
    colRight.appendChild(remarks);

    var btn = document.querySelector("#submit-quote");
    btn.classList.add("button-primary")
    colRight.appendChild(btn);

    var intro = document.createElement('div');
    intro.classList.add('qq-intro-text');
    var p1 = document.createElement("p");
    p1.innerText = "Please complete the form below and we will get back to you ASAP with formal quote."
    var p2 = document.createElement("p");
    p2.innerText = "To enable us to calculate accurate shipping costs, please make sure you enter your full address details – if you have any further questions or comments, please enter them in the 'remarks' field."
    var p3 = document.createElement("p");
    p3.innerText = "If you need to change the items or quantities on your quote, please go back to your shopping cart and make the changes there."

    intro.appendChild(p1);
    intro.appendChild(p2);
    intro.appendChild(p3);
    formColumns.before(intro)
    
    var err = document.querySelector("#quote-error-messages");
    formColumns.before(err);

    var req = document.querySelector(".quote-required-message");
    formColumns.before(req);

  
    
  }

  function setActive(){
   this.parentElement.classList.add("form-field-filled");
  }
  

  function toggleFilled(){
    let isFilled = this.value.length > 0;

    try {
      if(isFilled == true){
        this.parentElement.classList.add("form-field-filled");
      }else{
        this.parentElement.classList.remove("form-field-filled");
      }
    } catch (e) {
      this.parentElement.classList.remove("form-field-filled");
    }
  }
  
});

$('.key-details').on('click', 'a', function() {
    var title_pop = $(this).attr('title');
    if(title_pop == 'GA-POPUP')
    {
    gsc('show', 272005);
    }
});
$( document ).ready(function() {
  $("a.coolbox2").attr('href', "javascript: void(0);");
  });
$("a.coolbox2").click(function(e) {
    gsc('show', 329134);
    
});


$(document).click(function(e) {
    if (!$(e.target).is("#getsitecontrol-272005  .container")) {
       if ($('#getsitecontrol-272005').is(':visible')) {
        gsc('hide', 272005);
       }
    }
   if (!$(e.target).is("#getsitecontrol-329134  .container")) {
       if ($('#getsitecontrol-329134').is(':visible')) {
        gsc('hide', 329134);
       }
    }
});